import React from 'react';
import { FormRenderProps } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Button } from '@occc/ui-design-system';

import { LocationCreateForm } from './LocationCreateForm';
import { breadcrumbLinks } from './constants';

type ILocationCreateUpdateFormRenderComponentProps = Pick<
  FormRenderProps,
  'handleSubmit' | 'valid'
>;

const PAGE_TITLE = 'Create Location';

export const LocationCreateFormRenderComponent: React.FC<
  ILocationCreateUpdateFormRenderComponentProps
> = ({ handleSubmit, valid }) => {
  const navigate = useNavigate();

  useAppLayoutContextConsumer(breadcrumbLinks);

  const actions = [
    <Button
      key='cancel'
      variant='outlined'
      type='button'
      role='button'
      color='secondary'
      onClick={() => navigate(-1)}
    >
      Cancel
    </Button>,
    <Button
      key='save'
      variant='contained'
      color='primary'
      disabled={!valid}
      type='submit'
      onClick={handleSubmit}
    >
      Save
    </Button>,
  ];

  return (
    <Page browserTabTitle={PAGE_TITLE} pageHeaderProps={{ title: PAGE_TITLE }} actions={actions}>
      <LocationCreateForm handleSubmit={handleSubmit} />
    </Page>
  );
};
